import { useCallback } from 'react'
import { useLatest } from 'react-use'
import { Object3D } from 'three'
import { useControlStore } from '@editor/stores'

export type MarqueeSelectionListener = (ids: string[], objects: Object3D[]) => void

const useEmitMarqueeSelectionListener = () => {
  const marqueeSelectionListeners = useControlStore(state => state.marqueeSelectionListeners)
  const marqueeSelectionListenersRef = useLatest(marqueeSelectionListeners)

  const executeListeners = useCallback(
    (ids: string[], objects: Object3D[]) => {
      const listenersArray = Array.from(marqueeSelectionListenersRef.current.values())

      listenersArray.forEach(listenerConfig => {
        if (listenerConfig.enabled) {
          listenerConfig.listener(ids, objects)
        }
      })
    },
    [marqueeSelectionListenersRef],
  )

  return executeListeners
}

export default useEmitMarqueeSelectionListener
